if (window.__browserSupported) { import("/src/main.tsx"); }